/**
 * Which creative of a geo-targeted ad a visitor should see.
 *
 * Mirrors GeoLocationService::matchesCountrySelection() and the fallback rule that the
 * ad views used to apply on the server. components/ad-variants.blade.php applies the
 * same rules in the editor preview; keep the three in step.
 */

/**
 * @param {string}   userCountry Normalised code, e.g. "US", "GB-ENG", or "unknown".
 * @param {string[]} targets     Country codes selected on the row.
 * @return {boolean} Whether the row applies to this visitor.
 */
export function matchesCountrySelection( userCountry, targets ) {
	const user = String( userCountry || '' )
		.trim()
		.toUpperCase();
	if ( user === '' || user === 'UNKNOWN' ) {
		return false;
	}

	const normalized = targets.map( code => String( code ).trim().toUpperCase() ).filter( Boolean );
	if ( normalized.includes( user ) ) {
		return true;
	}

	// "United Kingdom" (GB) matches every UK nation.
	return user.startsWith( 'GB-' ) && normalized.includes( 'GB' );
}

/**
 * The first matching row wins; the fallback applies only when no row matches, and also
 * matches "all".
 *
 * @param {{countries: string[], fallback: boolean}[]} variants    In the ad's row order.
 * @param {string}                                     userCountry
 * @return {number} Index of the variant to show, or -1 for none.
 */
export function pickAdVariant( variants, userCountry ) {
	const row = variants.findIndex(
		variant => ! variant.fallback && matchesCountrySelection( userCountry, variant.countries )
	);
	if ( row !== -1 ) {
		return row;
	}

	return variants.findIndex(
		variant =>
			variant.fallback &&
			( matchesCountrySelection( userCountry, variant.countries ) ||
				variant.countries.includes( 'all' ) )
	);
}
